import { useEffect } from "react";
import { checkProductPromotion, displayPromotionToast, Promotion } from "@/utils/promotionUtils";

interface PromotionHandlerProps {
  productId: string;
  selectedCustomerId?: string;
  onPromotionChange: (promotion: Promotion | null) => void;
}

export const PromotionHandler = ({
  productId,
  selectedCustomerId,
  onPromotionChange,
}: PromotionHandlerProps) => {
  useEffect(() => {
    const checkPromotion = async () => {
      const promotion = await checkProductPromotion(productId, selectedCustomerId);
      
      if (promotion) {
        displayPromotionToast(promotion);
      }
      
      onPromotionChange(promotion);
    };

    checkPromotion();
  }, [productId, selectedCustomerId, onPromotionChange]);

  return null;
};